import stylesheet from './JobFact.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

export class NXTJobFact extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const element = document.createElement('div');
        element.classList.add('job-fact');
        element.innerHTML = `
            <slot name="label"></slot>
            <slot></slot>
        `;
        return element;
    }
}

customElements.define('nxt-job-fact', NXTJobFact);
